import { render, staticRenderFns } from "./SelectTestLanguage.vue?vue&type=template&id=7721be8e&"
import script from "./SelectTestLanguage.vue?vue&type=script&lang=js&"
export * from "./SelectTestLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports